import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './app/App';
import * as serviceWorker from './serviceWorker';

const search = window.location.search;
const params = new URLSearchParams(search);
const tvId = params.get('tvId');
const tvName = params.get('tvName');
const gpon = params.get('gpon');
const number = params.get('number');
const zipcode = params.get('zipcode');
const theme = params.get('theme');
const pathName = window.location.pathname;

const sendProps = {
  tvId,
  tvName,
  gpon,
  number,
  theme,
  zipcode,
  pathName,
};

ReactDOM.render(<App {...sendProps} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
